import * as React from 'react';

import { useApplicationContext } from '../../../utils/applicationContext';
import { replacePhoneNumbers } from '../utils';

export const useHiddenMessagePhones = ({
  messageUserId,
  isOutcoming,
  onClick,
}: {
  messageUserId: number;
  isOutcoming: boolean;
  onClick: () => void;
}): {
  replacePhoneNumbers: (text: string) => string | (string | React.ReactElement)[];
} => {
  const [isPhonesHidden, setIsPhonesHidden] = React.useState<boolean>(true);

  const { config } = useApplicationContext();

  const onMessagePhonesClick = React.useCallback(() => {
    if (isPhonesHidden) {
      onClick();
    }
    setIsPhonesHidden(false);
  }, [isPhonesHidden, onClick]);

  React.useEffect(() => {
    const isHiddenMessagePhonesEnabled = config.get<boolean>('frontend-chats.hiddenMessagePhones.Enabled') || false;
    const hiddenMessagePhonesUserIds = config.get<number[]>('frontend-chats.hiddenMessagePhonesUserIds') || [];

    if (isHiddenMessagePhonesEnabled && messageUserId && hiddenMessagePhonesUserIds.includes(messageUserId)) {
      setIsPhonesHidden(true);

      return;
    }

    setIsPhonesHidden(false);
  }, [messageUserId, config]);

  const replacePhoneNumbersCallback = React.useCallback(
    (text: string) => {
      return replacePhoneNumbers({
        text,
        isOutcoming,
        isPhonesHidden,
        onClick: onMessagePhonesClick,
      });
    },
    [isOutcoming, isPhonesHidden, onMessagePhonesClick],
  );

  return {
    replacePhoneNumbers: replacePhoneNumbersCallback,
  };
};
